import type { Evidence } from "@/types/content";
import { getEvidenceIcon } from "@/utils/content";

export default function EvidenceList({ evidences }: { evidences: Evidence[] }) {
  return (
    <ul className="mt-6 space-y-4">
      {evidences.map((evidence, index) => (
        <li
          key={evidence.title}
          className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6"
        >
          <div className="flex items-start gap-4">
            <span className="w-11 h-11 shrink-0 flex items-center justify-center rounded-md bg-primary-100 text-primary-300 text-xl">
              <i className={getEvidenceIcon(evidence.type)} />
            </span>
            <div className="min-w-0 flex-1">
              <div className="flex flex-wrap items-center gap-2">
                <span className="text-xs text-foreground-500">第 {index + 1} 条</span>
                <span className="px-2 py-0.5 rounded-md text-xs bg-background-200/70 text-foreground-600">
                  {evidence.type}
                </span>
                <span
                  className={`px-2 py-0.5 rounded-md text-xs border ${
                    evidence.verified
                      ? "bg-secondary-100 text-secondary-300 border-secondary-300/40"
                      : "bg-accent-100 text-accent-300 border-accent-300/40"
                  }`}
                >
                  {evidence.verified ? "来源已核实" : "待核实"}
                </span>
              </div>
              <h3 className="mt-2.5 font-heading text-base md:text-lg font-bold text-foreground-950">{evidence.title}</h3>
              <p className="mt-2 text-sm leading-7 text-foreground-500">{evidence.desc}</p>
              <p className="mt-3 flex items-center gap-1.5 text-xs text-foreground-500">
                <i className="ri-shield-user-line text-primary-500" />
                来源：{evidence.source}
              </p>
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
}